import { Auth, Permission } from '@justgiving/auth';
import { PropsWithChildren, createContext, useContext, useState } from 'react';

import { AccessToken } from '@justgiving/auth/src/types/AccessToken';
import { auth } from '../utils/auth';

type TAuthContext = {
  isUserLoggedIn: boolean;
  accessToken?: AccessToken;
  activeCharityPermission?: Permission;
  setAuth: (value: Auth) => void;
  userGuid?: string;
};

const AuthContext = createContext<TAuthContext | null>(null);

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const [_auth, setAuth] = useState(auth);
  const isUserLoggedIn = _auth.isUserLoggedIn();

  return (
    <AuthContext.Provider
      value={{
        isUserLoggedIn,
        accessToken: _auth.getAccessToken(),
        activeCharityPermission: _auth.getActivePermission('charity'),
        setAuth,
        userGuid: _auth.getAccessToken()?.guid,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuthenticatedUser() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthenticatedUser must be used within an AuthProvider');
  }

  return context;
}
